export const NewFinancialStage = {
  PreSeed: "PreSeed",
  Seed: "Seed",
  SeriesA: "SeriesA",
  SeriesB: "SeriesB",
  SeriesC: "SeriesC",
  SeriesD: "SeriesD",
  SeriesEPlus: "SeriesEPlus",
  Private: "Private",
  PrivateEquity: "PrivateEquity",
  Undetermined: "Undetermined",
  DebtFinancing: "DebtFinancing",
  IpoPublicMarket: "IpoPublicMarket",
  MergePrivateAcquisition: "MergePrivateAcquisition",
  OutOfBusiness: "OutOfBusiness",
  Grant: "Grant",
  Crowdfunding: "Crowdfunding"
};

export type TNewFinancialStage = keyof typeof NewFinancialStage;
